import { TransactionTypes } from 'nem-library';
import { DateTimeFormatter } from 'js-joda';
import Decimal from 'decimal.js';
import { getDivided } from "./numberUtils";
export class TransactionWrapper {
    get isConfirmed() {
        return this.transaction.isConfirmed();
    }
    get xemAmount() {
        if (this.transferTransaction.containsMosaics()) {
            return new Decimal(0);
        }
        else {
            if (this.isConfirmed) {
                return getDivided(this.transferTransaction.xem().quantity(), 6);
            }
            else {
                // Quantity of unconfirmed transaction is incorrect.
                return getDivided(this.transferTransaction.xem().amount, 6);
            }
        }
    }
    get mosaics() {
        if (this.transferTransaction.containsMosaics()) {
            return this.transferTransaction.mosaics();
        }
        else {
            return [];
        }
    }
    get timeWindow() {
        return this.transaction.timeWindow;
    }
    get message() {
        return this.transferTransaction.message;
    }
    get senderAddress() {
        if (this.transaction.signer) {
            return this.transaction.signer.address.pretty();
        }
        else {
            return '';
        }
    }
    get senderPublic() {
        if (this.transaction.signer) {
            return this.transaction.signer;
        }
        else {
            return null;
        }
    }
    get receiverAddress() {
        return this.transferTransaction.recipient.pretty();
    }
    get peer() {
        if (this.isReception) {
            return this.senderAddress;
        }
        else {
            return this.receiverAddress;
        }
    }
    get feeAmount() {
        return getDivided(this.transaction.fee, 6);
    }
    constructor(transaction, transferTransaction, isReception, isMultisig) {
        this.transaction = transaction;
        this.transferTransaction = transferTransaction;
        const dateFormatter = DateTimeFormatter.ofPattern('MM/dd yyyy');
        const timeFormatter = DateTimeFormatter.ofPattern('HH:mm:ss');
        this.dateString = this.timeWindow.timeStamp.format(dateFormatter);
        this.timeString = this.timeWindow.timeStamp.format(timeFormatter);
        this.isReception = isReception;
        this.isMultisig = isMultisig;
    }
    static fromTransferTransaction(transaction, accountAddress) {
        const isReception = (transaction.recipient.plain() === accountAddress.plain());
        return new TransactionWrapper(transaction, transaction, isReception, false);
    }
    static fromMultisigTransaction(transaction, accountAddress) {
        if (transaction.otherTransaction.type != TransactionTypes.TRANSFER) {
            return null;
        }
        const transferTransaction = transaction.otherTransaction;
        const isReception = (transferTransaction.recipient.plain() === accountAddress.plain());
        return new TransactionWrapper(transaction, transferTransaction, isReception, true);
    }
    static fromTransaction(transaction, accountAddress) {
        if (transaction.type == TransactionTypes.TRANSFER) {
            return this.fromTransferTransaction(transaction, accountAddress);
        }
        if (transaction.type == TransactionTypes.MULTISIG) {
            return this.fromMultisigTransaction(transaction, accountAddress);
        }
        return null;
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/lib/transactionWrapper.ts
// module id = 603
// module chunks = 1